import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeliveryNoteListComponent } from './deliverynote-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { DeliveryNoteService } from './deliverynote.service';

@Component({
    selector: 'convfact-deliverynotedelete',
    templateUrl: './deliverynote-dialog-delete.component.html',
    styleUrls: ['./deliverynote.component.css'],
    standalone: false
})
export class DeliveryNoteDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error: boolean = false;

    constructor(public dialogRef: MatDialogRef<DeliveryNoteListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public snackBar: MatSnackBar,
        public deliverynoteService: DeliveryNoteService) { }

    delete() {
        this.deliverynoteService.deleteData(this.uid);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }

}